import { create } from 'zustand';

interface SiteAlertState {
    isExpanded: boolean;
}

interface SiteAlertActions {
    toggleIsExpanded: () => void;
}

const useSiteAlertStore = create<SiteAlertState & SiteAlertActions>()(set => ({
    isExpanded: false,
    toggleIsExpanded() {
        set(state => ({
            isExpanded: !state.isExpanded
        }));
    }
}));

export default useSiteAlertStore;
